import config from "../config";

export const languages = [
	{
		label: "English",
		value: "en",
		icon: "🇺🇸",
	},
	{
		label: "简体中文",
		value: "zh",
		icon: "🇨🇳",
	},
	{
		label: "Malay",
		value: "ms",
		icon: "🇲🇾",
	},
];
